import React, { useState, useEffect } from 'react'
import { Link } from "react-router-dom";
import { ArrowBackIcon, ProfileIcon, ContactIcon } from "~/Components/Icons/Icons";
import { adminHttp } from "~/Admin/services/http";
import ConfirmedButton from "~/Components/ConfirmedButton/ConfirmedButton";
import { connect } from "react-redux";
import AdminUploadList from "~/Admin/AdminGuests/AdminDataUploads/AdminUploadLog/AdminUploadList";
import AdminHostInvitationForm from "~/Admin/AdminGuests/AdminDataUploads/AdminInviteHost/AdminHostInvitationForm";
import moment from "moment";

const AdminViewHost = ({ event, match, ...props }) => {

    const [eventHost, setEventHost] = useState(null);

    const [form, setForm] = useState({
        message: '',
        deadline: null,
    });

    const [errors, setErrors] = useState(null);
    const [message, setMessage] = useState('');
    const [success, setSuccess] = useState('');

    const handleFormChange = (values) => {
        setForm({ ...form, ...values });
    };

    const endpoint = '/events/' + event.id + '/hosts/' + match.params.id;

    const loadData = () => {
        adminHttp
            .get(endpoint)
            .then(res => {
                setEventHost(res.data);
                setForm({
                    message: res.data.message,
                    deadline: moment(res.data.deadline)
                });
            });
    };

    useEffect(loadData, [event]);

    const handleResend = () => {

        const res = adminHttp.post(endpoint + '/resend', form);

        res.then((res) => {

            setErrors(null);
            setMessage('');
            setSuccess('Invitation has been sent!');

        }).catch((err) => {

            const res = err.response;

            setErrors(res.data.errors);
            setMessage(res.data.message);
        });
    };

    if (!eventHost) {
        return <></>
    }

    return (
        <div>
            <Link to="/guests/uploads/hosts" className="btn btn-secondary btn-sm mb-4">
                <ArrowBackIcon classes="d-inline mr-2" />
                Back
            </Link>

            <div className="row">
                <div className="col-6">
                    <h2>{eventHost.host.full_name}</h2>
                </div>
                <div className="col-6 text-right">
                    <a target="_blank" href={eventHost.url} className="btn btn-secondary btn-icon btn-sm mr-3">
                        <ProfileIcon classes="d-inline mr-2" />
                        View Profile
                    </a>
                    <a href={'mailto:' + eventHost.host.email} className="btn btn-primary btn-icon btn-sm">
                        <ContactIcon classes="d-inline mr-2" />
                        Contact Host
                    </a>
                </div>
            </div>

            <div className="card shadow-sm bg-white mt-3">
                <div className="card-body">
                    {eventHost.uploads.length > 0 && (
                        <AdminUploadList uploads={eventHost.uploads} eventHost={eventHost} />
                    )}

                    {eventHost.uploads.length === 0 && (
                        <p>Host did not uploads any documents yet!</p>
                    )}
                </div>
            </div>

            <div className="card shadow-sm bg-white mt-3">
                <div className="card-body">
                    <h3>Host invitation</h3>

                    {message && (
                        <div className="alert alert-danger" role="alert">
                            {message}
                        </div>
                    )}

                    {success && (
                        <div className="alert alert-success" role="alert">
                            {success}
                        </div>
                    )}

                    <AdminHostInvitationForm values={form} errors={errors} onChange={handleFormChange} />

                    <ConfirmedButton
                        confirmText="Are you sure you want to confirm ?"
                        onClick={handleResend}
                        className="btn btn-primary text-cta align-self-end">
                        Re-send invitation
                    </ConfirmedButton>
                </div>
            </div>
        </div>
    );
}

const mapStateToProps = (state) => ({
    user: state.auth?.user,
    event: state.event.current,
});

export default connect(mapStateToProps)(AdminViewHost);
